// extracted by mini-css-extract-plugin
export default {"mb8":"spacing-styles_mb8__3Z1b1","mt16":"spacing-styles_mt16__YJrfw","my16":"spacing-styles_my16__6wCzP","my24":"spacing-styles_my24__Kgvbw","mb24":"spacing-styles_mb24__eC2l2"};